import Vue from "vue";
import VueRouter from "vue-router";
import frame from "../views/frame.vue";
import login from "../views/login.vue";
import applyCenter from "./module/applyCenter";
import user from "./module/user";
import configuration from "./module/configuration";
import activeCenter from "./module/activeCenter";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/apply/newVip/13/home", //重定向到会员中心
    component: frame,
    meta: {
      title: "后台"
    },
    children: [
      {
        path: "comModule",
        name: "comModule",
        meta: {
          title: "组件库"
        }
        // component: () => import("../views/apply")
      },
      {
        path: "apply",
        name: "apply",
        meta: {
          title: "应用中心"
        },
        redirect: "/apply/viewapp",
        component: {
          render: c => c("router-view")
        },
        children: [...applyCenter]
      },
      {
        path: "user",
        name: "user",
        redirect: "/user/infor",
        hidden: true,
        meta: {
          title: "用户中心"
        },
        component: () => import("../views/user/index.vue"),
        children: [...user]
      },
      {
        path: "configuration",
        name: "configuration",
        redirect: "/configuration/subScription",
        meta: {
          title: "配置信息"
        },
        component: () => import("../views/configuration/index.vue"),
        children: [...configuration]
      },
      {
        path: "activeCenter",
        name: "activeCenter",
        redirect: "/activeCenter/active",
        meta: {
          title: "活动中心"
        },
        component: () => import("../views/activeCenter/frame.vue"),
        children: [...activeCenter]
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/bigdata",
    name: "bigdata",
    meta: {
      title: "大数据看板"
    },
    component: () => import("@/views/apply/newVip/index")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
export default router;
